/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientReminderModel } from '../../models/patient-reminder-model';

export interface SavePatientReminder$Params {
      body?: PatientReminderModel
}

export function SavePatientReminder(http: HttpClient, rootUrl: string, params?: SavePatientReminder$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientReminderModel>> {
  const rb = new RequestBuilder(rootUrl, SavePatientReminder.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientReminderModel>;
    })
  );
}

SavePatientReminder.PATH = '/api/Supervisor/SavePatientReminder';
